// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICalendarEventPlanDto } from './ICalendarEventPlanDto';
import {
    ICalendarEventPlanDtoFromJSON,
    ICalendarEventPlanDtoFromJSONTyped,
    ICalendarEventPlanDtoToJSON,
    ICalendarEventPlanDtoToJSONTyped,
} from './ICalendarEventPlanDto';

/**
 * 
 * @export
 * @interface IEmployerCalendarEventDto
 */
export interface IEmployerCalendarEventDto {
    /**
     * 
     * @type {string}
     * @memberof IEmployerCalendarEventDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployerCalendarEventDto
     */
    category?: IEmployerCalendarEventDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployerCalendarEventDto
     */
    type?: IEmployerCalendarEventDtoTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerCalendarEventDto
     */
    event_date?: Date;
    /**
     * 
     * @type {Array<ICalendarEventPlanDto>}
     * @memberof IEmployerCalendarEventDto
     */
    plans?: Array<ICalendarEventPlanDto>;
    /**
     * 
     * @type {number}
     * @memberof IEmployerCalendarEventDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployerCalendarEventDto
     */
    invoice_status?: string;
}

/**
* @export
* @enum {string}
*/
export enum IEmployerCalendarEventDtoCategoryEnum {
    PLAN_DATES = 'PLAN_DATES',
    FUNDING = 'FUNDING'
}
/**
* @export
* @enum {string}
*/
export enum IEmployerCalendarEventDtoTypeEnum {
    PLAN_START_DATE = 'PLAN_START_DATE',
    PLAN_END_DATE = 'PLAN_END_DATE',
    GRACE_PERIOD_END_DATE = 'GRACE_PERIOD_END_DATE',
    RUNOUT_END_DATE = 'RUNOUT_END_DATE',
    ROLLOVER_DATE = 'ROLLOVER_DATE',
    FORFEITURE_DATE = 'FORFEITURE_DATE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    SCHEDULED_REPLENISHMENT_INVOICE = 'SCHEDULED_REPLENISHMENT_INVOICE',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    SCHEDULED_CONTRIBUTIONS = 'SCHEDULED_CONTRIBUTIONS'
}


/**
 * Check if a given object implements the IEmployerCalendarEventDto interface.
 */
export function instanceOfIEmployerCalendarEventDto(value: object): value is IEmployerCalendarEventDto {
    return true;
}

export function IEmployerCalendarEventDtoFromJSON(json: any): IEmployerCalendarEventDto {
    return IEmployerCalendarEventDtoFromJSONTyped(json, false);
}

export function IEmployerCalendarEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployerCalendarEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'category': json['category'] == null ? undefined : json['category'],
        'type': json['type'] == null ? undefined : json['type'],
        'event_date': json['event_date'] == null ? undefined : (new Date(json['event_date'])),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(ICalendarEventPlanDtoFromJSON)),
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_status': json['invoice_status'] == null ? undefined : json['invoice_status'],
    };
}

export function IEmployerCalendarEventDtoToJSON(json: any): IEmployerCalendarEventDto {
    return IEmployerCalendarEventDtoToJSONTyped(json, false);
}

export function IEmployerCalendarEventDtoToJSONTyped(value?: IEmployerCalendarEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category': value['category'],
        'type': value['type'],
        'event_date': value['event_date'] == null ? undefined : ((value['event_date']).toISOString().substring(0,10)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(ICalendarEventPlanDtoToJSON)),
        'invoice_id': value['invoice_id'],
        'invoice_status': value['invoice_status'],
    };
}

